export default {
  resource: "user.userActivity",

  map() {
    this.route("solved");
  },
};
